(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["its-coffee-brands"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('its-coffee-brands'))customElements.define('its-coffee-brands',class extends HTMLElement{
async connectedCallback(){if(this.ready)return;this.ready=true;this.track=this.querySelector('.its-coffee__track');this.pause=this.querySelector('.its-coffee__pause');this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.reduced.matches;this.hovering=false;this.querySelector('.its-coffee__next').addEventListener('click',()=>this.step(1));this.querySelector('.its-coffee__prev').addEventListener('click',()=>this.step(-1));this.track.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();this.step(e.key==='ArrowRight'?1:-1)}});this.addEventListener('mouseenter',()=>this.hovering=true);this.addEventListener('mouseleave',()=>this.hovering=false);this.track.addEventListener('pointerdown',()=>{this.paused=true;this.updatePause()});if(this.pause)this.pause.addEventListener('click',()=>{this.paused=!this.paused;this.updatePause()});this.updatePause();await Promise.allSettled(Array.from(this.querySelectorAll('img'),img=>img.decode()));if(!this.isConnected)return;if(this.dataset.autoplay==='true')this.timer=setInterval(()=>{if(!this.paused&&!this.hovering&&!document.hidden&&!this.contains(document.activeElement))this.step(1)},4000)}
step(direction){const distance=this.track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap);const end=this.track.scrollWidth-this.track.clientWidth;const behavior=this.reduced.matches?'instant':'smooth';if(direction>0&&this.track.scrollLeft>=end-3)this.track.scrollTo({left:0,behavior});else if(direction<0&&this.track.scrollLeft<3)this.track.scrollTo({left:end,behavior});else this.track.scrollBy({left:direction*distance,behavior})}
updatePause(){if(this.pause){this.pause.textContent=this.paused?this.dataset.play:this.dataset.pause;this.pause.setAttribute('aria-pressed',String(this.paused))}}
disconnectedCallback(){clearInterval(this.timer);this.ready=false}
});

  } catch(e) { console.error(e); }
})();
})();
